import { Icon, Popconfirm, Row } from "antd";
import Text from "antd/lib/typography/Text";
import React, { useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Component for ordering component by dragging and dropping
const SortableItem = SortableElement(
    ({ item, currentIndex, handleFaqChange, deleteFaq, setsortingflag , imageUploadHandler}) => {
        return (
            <div
                style={{
                    display: "flex",
                    padding: "12px 0",
                    alignItems: "flex-start",
                }}
            >
                <Icon
                    type="menu"
                    style={{
                        marginTop: "14px",
                        fontWeight: "lighter",
                        color: "#A3A3A3",
                    }}
                />
                <div
                    style={{
                        flexGrow: "1",
                        padding: "0 12px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <input
                        style={{
                            padding: "8px 12px",
                            marginBottom: "8px",
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "24px",
                            border: "1px solid #E8E8E8",
                            boxSizing: "border-box",
                            borderRadius: "4px",
                            color: "#181818",
                            outline: "none",
                        }}
                        type="text"
                        placeholder="Question"
                        value={item?.question}
                        onChange={(e) =>
                            handleFaqChange(e.target.value, currentIndex, "q")
                        }
                    />
                    
                    <Editor
                        apiKey='5uv78fphj9sndnha6xh30qanrvek9n49j9z9bcykz2ki9i06'
                        onFocus={() => setsortingflag(true)}
                        onBlur={() => setsortingflag(false)}
                        style={{
                            border: "1px solid #E8E8E8",
                        }}
                        value={item?.answer}
                        onEditorChange={(newValue, editor) => {
                            handleFaqChange(newValue, currentIndex, "a");
                        }}
                        init={{
                            height: 200,
                            menubar: true,
                            image_uploadtab: true,
                            file_picker_types: "image",
                            images_upload_handler: imageUploadHandler,
                            // images_upload_credentials: true,
                            plugins: [
                                "advlist autolink lists link image charmap print preview anchor",
                                "searchreplace visualblocks code fullscreen",
                                "insertdatetime media table paste code help wordcount",
                            ],
                            toolbar:
                                "undo redo | formatselect  | bold italic | alignleft aligncenter " +
                                "alignright alignjustify | bullist numlist outdent indent | " +
                                "removeformat | help",
                            content_style: "body { font-family: Helvetica }",
                        }}
                    />
                </div>
                <Popconfirm
                    placement="topRight"
                    title={"Are you sure?"}
                    icon={
                        <Icon
                            type="question-circle-o"
                            style={{ color: "red" }}
                        />
                    }
                    onConfirm={() => {
                        deleteFaq(currentIndex);
                    }}
                    okText="Yes"
                    cancelText="No"
                >
                    <button style={{ background: "none", border: "none" }}>
                        <Icon
                            type="delete"
                            style={{
                                fontSize: "18px",
                                marginTop: "12px",
                                fontWeight: "lighter",
                                color: "#A3A3A3",
                                pointerEvents: "none",
                            }}
                        />
                    </button>
                </Popconfirm>
            </div>
        );
    }
);

const SortableList = SortableContainer(({ items,imageUploadHandler, ...rest }) => {
    // const [activeIndex, setActiveIndex] = useState(0);
    const [viewMore, setViewMore] = useState(false);
    const [sortingflag, setsortingflag] = useState(true);

    return (
        <Row
            style={{
                width: "100%",
                padding: "24px",
                marginTop: "8px",

                backgroundColor: "#FFFFFF",
                border: "1px solid #D1D1D1",
                borderRadius: "8px",
            }}
        >
            {items
                ?.slice(0, viewMore ? items?.length : 3)
                ?.map((item, index) => (
                    <SortableItem
                        {...rest}
                        key={index}
                        index={index}
                        currentIndex={index}
                        item={item}
                        disabled={sortingflag}
                        setsortingflag={setsortingflag}
						imageUploadHandler={imageUploadHandler}
                    />
                ))}

            <Row
                style={{
                    // padding: "20px",
                    marginTop: "8px",
                    textAlign: "center",
                    color: "#fec708",

                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "16px",
                    lineHeight: "24px",

                    cursor: "pointer",
                }}
                onClick={() => items.length > 3 && setViewMore(!viewMore)}
            >
                {items?.length > 3 ? (
                    <>
                        <Icon
                            type={viewMore ? "up" : "down"}
                            style={{ marginRight: "10px" }}
                        />{" "}
                        {`View ${viewMore ? "Less" : "More"}`}
                    </>
                ) : (
                    !items?.length && (
                        <div style={{ marginTop: "-8px", color: "#8A8A8A" }}>
                            No Faqs yet!
                        </div>
                    )
                )}
            </Row>
        </Row>
    );
});

const FAQSection = ({ faqList, setFaqList,imageUploadHandler }) => {
    Array.prototype.move = function (from, to) {
        this.splice(to, 0, this.splice(from, 1)[0]);
    };

    const handleFaqSort = (object) => {
        if (object.newIndex !== object.oldIndex) {
            let faqList_copy = [...faqList];
            faqList_copy.move(object.oldIndex, object.newIndex);
            setFaqList(faqList_copy);
        }
    };

    const handleFaqChange = (data, index, type) => {
        let faqList_copy = [...faqList];
        type === "q"
            ? (faqList_copy[index].question = data)
            : (faqList_copy[index].answer = data);
        setFaqList(faqList_copy);
    };

    const addNewFaq = () => {
        let faqList_copy = [...faqList];
        let tempFaq = {
            question: "",
            answer: "",
        };
        faqList_copy.push(tempFaq);
        setFaqList(faqList_copy);
    };

    const deleteFaq = (index) => {
        let faqList_copy = [...faqList];
        faqList_copy.splice(index, 1);
        setFaqList(faqList_copy);
    };

    return (
        <>
            <Row
                style={{
                    padding: "20px",
                    marginTop: "8px",
                    textAlign: "center",
                    color: "#464646",

                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "22px",

                    cursor: "pointer",
                    backgroundColor: "#FFFFFF",
                    border: "1px dashed #D1D1D1",
                    borderRadius: "8px",
                }}
                onClick={addNewFaq}
            >
                <Icon type="plus" style={{ marginRight: "10px" }} />
                Add New FAQ
            </Row>
            <SortableList
                items={faqList}
                onSortEnd={handleFaqSort}
                handleFaqChange={handleFaqChange}
                deleteFaq={deleteFaq}
				imageUploadHandler={imageUploadHandler}
            />
        </>
    );
};

export default FAQSection;
